import { faHeart } from "@fortawesome/duotone-regular-svg-icons/faHeart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Anchor, Tooltip } from "@mantine/core";
import { useState } from "react";
import { useUser } from "../../firestore/user/useUser";
import { useFavoritesEnabled } from "../../hooks/config/useFavoritesEnabled";
import classes from "./FavoriteCampgroundButton.module.css";

const FavoriteCampgroundButton = ({
  campgroundId,
}: {
  campgroundId: string;
}) => {
  const { addFavorite, isFavorite, removeFavorite } = useUser();
  const [animation, setAnimation] = useState("");
  const isFavoriteCampground = isFavorite(campgroundId);
  const areFavoritesEnabled = useFavoritesEnabled();
  if (!areFavoritesEnabled) {
    return null;
  }

  return (
    <Tooltip label={(isFavoriteCampground ? "remove" : "add") + " favorite"}>
      <Anchor
        left={0}
        autoFocus={false}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          const favFn = isFavoriteCampground ? removeFavorite : addFavorite;
          favFn(campgroundId);
          setAnimation(
            !isFavoriteCampground
              ? classes.pulse
              : ""
          );
        }}
      >
        <FontAwesomeIcon
          className={animation}
          icon={faHeart}
          color={isFavoriteCampground ? "red" : "gray"}
        />
      </Anchor>
    </Tooltip>
  );
};

export default FavoriteCampgroundButton;
